/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strava_Upstream_FailedInputs */

const en_us2_strava_upstream_failed = /** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strava did not answer. Try again later.`)
};

const pt_br2_strava_upstream_failed = /** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Strava não respondeu. Tente de novo mais tarde.`)
};

const pt_pt2_strava_upstream_failed = /** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Strava não respondeu. Tente de novo mais tarde.`)
};

/** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */
const es_419_strava_upstream_failed = en_us2_strava_upstream_failed;

/** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */
const fr_fr2_strava_upstream_failed = en_us2_strava_upstream_failed;

/** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */
const de_de2_strava_upstream_failed = en_us2_strava_upstream_failed;

/** @type {(inputs: Strava_Upstream_FailedInputs) => LocalizedString} */
const it_it2_strava_upstream_failed = en_us2_strava_upstream_failed;

/**
* | output |
* | --- |
* | "Strava did not answer. Try again later." |
*
* @param {Strava_Upstream_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const strava_upstream_failed = /** @type {((inputs?: Strava_Upstream_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strava_Upstream_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_strava_upstream_failed(inputs)
	if (locale === "es-419") return es_419_strava_upstream_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_strava_upstream_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_strava_upstream_failed(inputs)
	if (locale === "de-DE") return de_de2_strava_upstream_failed(inputs)
	if (locale === "it-IT") return it_it2_strava_upstream_failed(inputs)
	return en_us2_strava_upstream_failed(inputs)
});
export { strava_upstream_failed as "strava.upstream_failed" }